import React from 'react';
import { observer } from 'mobx-react';
import Logo from 'components/Logo';
import { isInDesktopMode } from 'libs/gutClient/electronBridge';
import { useClientStore, useRouterStore } from 'apps/hooks';
import { useGetSystemCondition } from 'hooks';
import { DefaultMenuRoute } from 'constants/global';

export type WikiFormWrapperProps = {
  className?: string;
  hiddenLogo?: boolean;
  headerRight?: React.ReactNode;
  style?: React.CSSProperties;
  logoType?:
    | 'app'
    | 'box'
    | 'brandName'
    | 'default'
    | 'branded'
    | 'black'
    | 'trademark';
};

export const WikiWrapper: React.FC<WikiFormWrapperProps> = observer(
  ({
    style,
    children,
    logoType,
    hiddenLogo = false,
    headerRight,
    className = '',
  }) => {
    const { navigate } = useRouterStore();
    const clientStore = useClientStore();

    const { shouldGotoConfirmProfilePage, isLoggedIn } =
      useGetSystemCondition();

    const handleClickLogo = () => {
      if (isLoggedIn) {
        navigate(DefaultMenuRoute, {
          spacePath: clientStore.slugFromRouteOrSpace,
        });
        return;
      }

      if (shouldGotoConfirmProfilePage) {
        navigate('onboarding.confirmProfile');
      }
    };

    const renderLogo = () => {
      const desktopMode = isInDesktopMode();

      if (desktopMode) {
        return !hiddenLogo && <Logo variant={logoType || 'branded'} />;
      }

      if (!isLoggedIn) {
        return (
          <a className=' text-black' href='/'>
            <Logo variant={logoType || 'branded'} />
          </a>
        );
      }

      return (
        <div onClick={handleClickLogo}>
          {!hiddenLogo && <Logo variant={logoType || 'branded'} />}
        </div>
      );
    };

    return (
      <div
        className={`p-8 min-h-screen flex flex-col ${className}`}
        style={style}
      >
        <div className='flex justify-between'>
          <div className='w-fit' data-testid='wikiPage-logo-icon'>
            {renderLogo()}
          </div>
          {headerRight}
        </div>
        {children}
      </div>
    );
  },
);
